import dayjs, { Dayjs } from 'dayjs';
import padStart from 'lodash/padStart';

import { Image } from '@ui/Image';
import { useTimer } from '@hook/useTimer';

import s from './ProductDetailsBigSaleBanner.sss';

interface Highlighting {
  title: string,
  icon: string,
  color: string,
}

interface Props {
  startDate: Dayjs,
  endDate: Dayjs,
  highlighting: Highlighting,
}

export const ProductDetailsBigSaleBanner: React.FC<Props> = ({
  startDate,
  endDate,
  highlighting,
}) => {
  const { duration } = useTimer({
    initialStart: true,
    initialTime: dayjs.duration(dayjs(endDate).diff()),
  });

  const { icon, title, color } = highlighting;

  const hours = padStart(Math.floor(duration.asHours()).toString(), 2, '0');
  const minutes = padStart(Math.floor((duration.asHours() % 1) * 60).toString(), 2, '0');
  const seconds = padStart(Math.floor(duration.asSeconds() % 60).toString(), 2, '0');

  return (
    <div
      className={s.root}
      style={{
        backgroundColor: color,
      }}
    >
      {!!icon && (
        <Image
          className={s.icon}
          src={icon}
          width="24"
          height="24"
        />
      )}
      <span className={s.title}>
        {title}
      </span>
      {dayjs().isAfter(startDate) && (
        <span className={s.timer}>
          {`${hours}:${minutes}:${seconds}`}
        </span>
      )}
    </div>
  );
};
